// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"40":"c97456786e6aa84fe3de04095b50d7214b67ac20","266":"2c796e83","415":"component---src-pages-404-jsx","615":"component---src-pages-storyblok-preview-jsx"}[chunkId] + "-" + {"40":"adef58c305925148b79e","266":"ae611b22eaa979dd97a9","415":"3f34a411790205f67064","615":"97c27dca8bf2492a32b6"}[chunkId] + ".js";
};